/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './object-node.component.scss.shim.ngstyle';
import * as i1 from '../node.component.scss.shim.ngstyle';
import * as i2 from '@angular/core';
import * as i3 from '../any-type-node.component.ngfactory';
import * as i4 from '../../../../../app/multi-editor/json-tree/any-type-node.component';
import * as i5 from '@angular/common';
import * as i6 from '../../../../../app/multi-editor/json-tree/object-node/object-node.component';
const styles_ObjectNodeComponent:any[] = [i0.styles,i1.styles];
export const RenderType_ObjectNodeComponent:i2.RendererType2 = i2.ɵcrt({encapsulation:0,
    styles:styles_ObjectNodeComponent,data:{}});
function View_ObjectNodeComponent_2(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),0,'i',[['aria-hidden',
      'true'],['class','collapsable fa  fa-caret-right fa-1']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.isExpandedMap.set((<any>_v.parent).context.$implicit,
          true)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(null as any));
}
function View_ObjectNodeComponent_3(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),0,'i',[['aria-hidden',
      'true'],['class','collapsable fa fa-caret-down fa-1']],(null as any),[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.isExpandedMap.set((<any>_v.parent).context.$implicit,
          false)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(null as any));
}
function View_ObjectNodeComponent_4(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n      '])),(_l()(),i2.ɵeld(2,0,(null as any),(null as any),
      1,'re-any-type-node',([] as any[]),(null as any),(null as any),(null as any),
      i3.View_AnyTypeNodeComponent_0,i3.RenderType_AnyTypeNodeComponent)),i2.ɵdid(3,
      114688,(null as any),0,i4.AnyTypeNodeComponent,([] as any[]),{value:[0,'value'],
          diff:[1,'diff'],depth:[2,'depth'],expanded:[3,'expanded']},(null as any)),
      (_l()(),i2.ɵted(-1,(null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.value[(<any>_v.parent).context.$implicit];
    const currVal_1:any = _co.patchesMap.get((<any>_v.parent).context.$implicit);
    const currVal_2:any = (_co.depth + 1);
    const currVal_3:any = _co.isExpandedMap.get((<any>_v.parent).context.$implicit);
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_ObjectNodeComponent_5(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),4,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n      '])),(_l()(),i2.ɵeld(2,0,(null as any),(null as any),
      1,'re-any-type-node',([] as any[]),(null as any),(null as any),(null as any),
      i3.View_AnyTypeNodeComponent_0,i3.RenderType_AnyTypeNodeComponent)),i2.ɵdid(3,
      114688,(null as any),0,i4.AnyTypeNodeComponent,([] as any[]),{value:[0,'value'],
          depth:[1,'depth'],expanded:[2,'expanded']},(null as any)),(_l()(),i2.ɵted(-1,
      (null as any),['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.value[(<any>_v.parent).context.$implicit];
    const currVal_1:any = (_co.depth + 1);
    const currVal_2:any = _co.isExpandedMap.get((<any>_v.parent).context.$implicit);
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_ObjectNodeComponent_1(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),20,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i2.ɵted(-1,(null as any),['\n  '])),(_l()(),i2.ɵeld(2,0,(null as any),(null as any),
      17,'span',([] as any[]),[[4,'margin-left','px']],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ObjectNodeComponent_2)),
      i2.ɵdid(5,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ObjectNodeComponent_3)),
      i2.ɵdid(8,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵeld(10,0,(null as any),(null as any),2,'span',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),i2.ɵdid(11,278528,
          (null as any),0,i5.NgClass,[i2.IterableDiffers,i2.KeyValueDiffers,i2.ElementRef,
              i2.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i2.ɵted(12,
          (null as any),['',''])),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),(_l()(),
          i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ObjectNodeComponent_4)),
      i2.ɵdid(15,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ObjectNodeComponent_5)),
      i2.ɵdid(18,16384,(null as any),0,i5.NgIf,[i2.ViewContainerRef,i2.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i2.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i2.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:boolean = !_co.isExpandedMap.get(_v.context.$implicit);
    _ck(_v,5,0,currVal_1);
    const currVal_2:any = _co.isExpandedMap.get(_v.context.$implicit);
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = _co.getPropertyStyle(_v.context.$implicit);
    _ck(_v,11,0,currVal_3);
    const currVal_5:any = ((_co.diff && _co.diffKeys.has(_v.context.$implicit)) || _co.shouldExpandKeys);
    _ck(_v,15,0,currVal_5);
    const currVal_6:any = (((_co.diff === (undefined as any)) || !_co.diffKeys.has(_v.context.$implicit)) && !_co.shouldExpandKeys);
    _ck(_v,18,0,currVal_6);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.depth * _co.levelOffsetInPixels);
    _ck(_v,2,0,currVal_0);
    const currVal_4:any = _v.context.$implicit;
    _ck(_v,12,0,currVal_4);
  });
}
export function View_ObjectNodeComponent_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ObjectNodeComponent_1)),i2.ɵdid(1,802816,(null as any),0,i5.NgForOf,[i2.ViewContainerRef,
      i2.TemplateRef,i2.IterableDiffers],{ngForOf:[0,'ngForOf'],ngForTrackBy:[1,'ngForTrackBy']},
      (null as any))],(_ck,_v) => {
    var _co:i6.ObjectNodeComponent = _v.component;
    const currVal_0:any = _co.keys;
    const currVal_1:any = _co.trackByItem;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_ObjectNodeComponent_Host_0(_l:any):i2.ɵViewDefinition {
  return i2.ɵvid(0,[(_l()(),i2.ɵeld(0,0,(null as any),(null as any),1,'re-object-node',
      ([] as any[]),(null as any),(null as any),(null as any),View_ObjectNodeComponent_0,
      RenderType_ObjectNodeComponent)),i2.ɵdid(1,114688,(null as any),0,i6.ObjectNodeComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ObjectNodeComponentNgFactory:i2.ComponentFactory<i6.ObjectNodeComponent> = i2.ɵccf('re-object-node',
    i6.ObjectNodeComponent,View_ObjectNodeComponent_Host_0,{value:'value',diff:'diff',
        depth:'depth',expanded:'expanded'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/json-tree/object-node/object-node.component.ngfactory.ts